import { Separator, Stack } from "@fluentui/react";

enum TranslateAccountInfoField {
  EMAIL = "Email",
  PHONE_NUMBER = "Telefone",
  WHATSAPP = "Whatsapp"
}

interface IInfoCamp {
  title?: string;
  value: string | { title: string; value: string }[];
  separator?: string;
}

export const InfoCamp = ({
  title,
  value
}: {
  title?: string;
  value?: string | IInfoCamp[];
}): JSX.Element => {
  const textColor = value ? undefined : "red";

  return (
    <div
      style={{
        lineHeight: 1.2,
        overflowWrap: "break-word",
        maxWidth: "17rem"
      }}
    >
      {title && (
        <div
          className="ms-fontWeight-semibold"
          style={{ width: "280px", color: textColor }}
        >
          {title}
        </div>
      )}

      {typeof value === "string" ? (
        <div>{value}</div>
      ) : (
        <Stack>
          {value?.map((data, idx) => {
            let text: string | { title: string; value: string }[];

            if (data?.title) {
              const label =
                TranslateAccountInfoField[
                  data?.title as keyof typeof TranslateAccountInfoField
                ] || data?.title;

              if (typeof data?.value === "string") {
                text = `${label}: ${data.value}`;
              } else if (Array.isArray(data?.value)) {
                text = data.value.map(item => ({
                  title: label,
                  value: item.value
                }));
              } else {
                text = `${label}: `;
              }
            } else {
              text = data?.value;
            }

            const mapTextColor = data.value ? undefined : "red";
            const maxFontWeight = data.value ? undefined : "bolder";

            if (data.separator) {
              return <Separator key={`separator-${idx}`} />;
            }

            return (
              <span
                key={`${idx}`}
                style={{
                  overflowWrap: "break-word",
                  color: mapTextColor,
                  fontWeight: maxFontWeight
                }}
              >
                {(() => {
                  if (typeof text === "string") {
                    return text;
                  }

                  if (Array.isArray(text)) {
                    return text.map((item, index) => (
                      <div key={index}>
                        <strong>{item.title}: </strong>
                        {item.value}
                      </div>
                    ));
                  }

                  return null;
                })()}
              </span>
            );
          })}
        </Stack>
      )}
    </div>
  );
};
